import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';   //importing hoc this will also force component to take full space of screen
import ReactTooltip from 'react-tooltip'; //importing reacttooltip dependency
import './Skills.scss';

import { urlFor, client } from '../../client';  //importing backend connection files

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {  //requesting data from backend
    const query = '*[_type == "experiences"]';  //for fetching experiences section from backend
    const skillsQuery = '*[_type == "skills"]';  //for fetching skills section from backend
    client.fetch(query).then((data) => {
      const sortedData = data.sort((a, b) => a.year - b.year);
      setExperiences(sortedData);
    })
    client.fetch(skillsQuery).then((data) => { setSkills(data); })  //will return a promise
  }, []);  //passing empty array as only want to run it once at the start component get mount type

  return (
    <>
      {/*SKILL SECTION */}
      <h2 className="head-text white-head">Skills <span>&</span> Experiences</h2>
      <div className="app__skills-container">
        <motion.div className='app__skills-list'>
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className='app__skills-item app__flex'
              key={skill.name}>  {/*for each skill returning a motion div */}
              <div className="app__flex" style={{ backgroundColor: skill.bgColor }}>
                <img src={urlFor(skill.icon)} alt={skill.name} />  {/*all these props are defined in sanity backend bgColor, icon , name etc */}
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        {/*EXPERIENCE SECTION update experience section on backend */}
        <div className='app__skills-exp'>
          {experiences.map((experience) => (
            <motion.div
              className='app__skills-exp-item'
              key={experience.year}>  {/*first sorting on the basis of year*/}
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className='app__skills-exp-works'>
                {experience.works.map((work) => (
                  <div key={work.name}>  {/* then arranging depending upon works */}
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className='app__skills-exp-work'
                      data-tip   //property provide when we're using a tooltip
                      data-for={work.name}
                      key={work.name}>  {/*for each work returning a motion div */}
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      offset={{ top: 1, left: 90 }}
                      arrowColor="#fff"
                      className="skills-tooltip">  {/* component created for providing more info when hovering the particular work */}
                      {work.desc}
                    </ReactTooltip>
                  </div>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  )
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg'
);  //using HOC and setting skill, first wrapping in Addwrap and then wrapping the main comp in motionwrap

